import Vue from 'vue';
import { AMAP_KEY, AMAP_SECRET, AMAP_PLUGINS } from '@/utils/constants'
import { Dialog, Toast } from 'vant';
import { loadJS } from '@/utils/asyncLoad';
import { isWxWork, isDeviceMobile } from '@/utils/index'

const getClientType = () => {
  if (isWxWork() && isDeviceMobile()) return 'WECOM'
  if (isWxWork()) return 'PCWECOM'
  return 'PCWECOM'
}

export async function getUserPositionByAmap() {
  window._AMapSecurityConfig = {
    securityJsCode: AMAP_SECRET,
  }
  if (!window.AMap) {
    await loadJS('https://webapi.amap.com/loader.js')
    await loadJS(`https://webapi.amap.com/maps?v=2.0&key=${AMAP_KEY}&plugin=${AMAP_PLUGINS}`)
  }
  return new Promise((resolve, reject) => {
    const geolocation = new AMap.Geolocation({
      enableHighAccuracy: true,
      timeout: 10000,
      offset: [10, 20],
      zoomToAccuracy: true,
      position: 'RB',
    })
    geolocation.getCurrentPosition((status, result) => {
      if (status === 'complete') {
        resolve({
          longitude: result.position.lng,
          latitude: result.position.lat,
          locationChannel: 'amap',
        })
      } else {
        reject(result)
      }
    })
  })
}

export function getUserPositionByWorkwx() {
  return new Promise(async (resolve, reject) => {
    const clientType = getClientType()
    if (clientType === 'PCWECOM' || clientType === 'PC') {
      console.log('getUserPositionByWorkwx skip', clientType)
      reject(new Error('非手机企微环境不调用企微定位'))
      return
    }
    console.log('getUserPositionByWorkwx start', typeof ww);
    if (typeof ww !== 'undefined' && ww.getLocation) {
      ww.getLocation({
        type: 'gcj02',
        success: (res) => {
          console.log('getUserPositionByWorkwx success', '企微未初始化')
          resolve({
            longitude: res.longitude,
            latitude: res.latitude,
            locationChannel: 'workwx',
          })
        },
        fail: (err) => {
          console.log('getUserPositionByWorkwx fail', err)
          reject(err)
        },
        cancel: () => {
          console.log('getUserPositionByWorkwx cancel')
        },
        complete: () => {
          console.log('getUserPositionByWorkwx complete')
        }
      })
    } else {
      console.log('getUserPositionByWorkwx error', '企微未初始化')
      reject(new Error('企微获取定位失败'))
    }
  })
}

export async function getUserPosition() {
  console.log('====GPS====', '开始获取定位')
  try {
    console.log('====GPS====', '高德开始获取定位')
    const result = await getUserPositionByAmap()
    console.log('====GPS====', '高德获取定位成功', result)
    return result
  } catch (error) {
    console.log('====GPS====', '高德获取定位失败', error)
    try {
      console.log('====GPS====', '企微开始获取定位')
      const result = await getUserPositionByWorkwx()
      console.log('====GPS====', '企微获取定位成功', result)
      return result
    } catch (workwxError) {
      console.log('====GPS====', '企微获取定位失败', workwxError)
      throw new Error('获取定位失败')
    }
  }
}

const parseWhiteListResult = (resp) => {
  if (resp?.code != 200) return false
  const data = resp?.data
  if (typeof data === 'boolean') return data
  if (data && typeof data === 'object') {
    if ('result' in data) return !!data.result
    if ('inWhiteList' in data) return !!data.inWhiteList
  }
  return !!(resp?.result ?? resp?.ret)
}

const isPointInWhiteList = async (pointName) => {
  if (!pointName) return false
  let vuexInfo = sessionStorage.getItem('vuex')
  if (vuexInfo) {
    vuexInfo = JSON.parse(vuexInfo)
  }
  let userIdCode = vuexInfo?.userInfo?.userIdCode
  const resp = await $http.post('gpsCollectCheck', {
    scene: pointName, // REGISTER/ORDER/PICKUP/PAY
    clientType: getClientType(),
    userIdCode,
  })
  console.log(resp);
  
  return resp?.data === false ? true : false
}

const WHITELIST_LOCATION = {
  longitude: '',
  latitude: '',
  locationChannel: 'whitelist',
}

const isPcClient = () => {
  const clientType = getClientType()
  return clientType === 'PCWECOM' || clientType === 'PC'
}

const showLocationFailDialog = () => {
  if (isPcClient()) {
    window.tracker && window.tracker.report({
      "pageName":"gpsrefuse_layer",
      "eventType":"pv",
      "eventId":"gpsrefuse_layer_view",
      ex1: window.location.href,
      ex2: 'pc',
    })
    return Dialog.alert({
      title: '请使用手机操作',
      message: '电脑端无法获取定位，请使用手机企业微信打开本页面后继续操作。',
      confirmButtonText: '我知道了',
      confirmButtonColor: '#ff6015',
    })
  }
  window.tracker && window.tracker.report({
    "pageName":"gpsrefuse_layer",
    "eventType":"pv",
    "eventId":"gpsrefuse_layer_view",
    ex1: window.location.href,
    ex2: 'h5',
  })
  return Dialog.alert({
    title: '定位失败',
    message: '因为您不允许使用精确位置，后续访问会受限制。请关闭弹窗后，确保手机设置中定位打开，企微应用位置授权打开，并允许获取位置信息',
    confirmButtonText: '我知道了',
    confirmButtonColor: '#ff6015',
  })
}

// Vue.prototype.$gpsLock = async (pointName) => {
//   try {
//     return await getUserPosition()
//   } catch (error) {
//     try {
//       const isInWhiteList = await isPointInWhiteList(pointName)
//       console.log('白名单校验结果', isInWhiteList)
//       if (isInWhiteList) {
//         return { ...WHITELIST_LOCATION }
//       } else {
//         // await showLocationFailDialog()
//         throw error
//       }
//     } catch (err) {
//       console.log('白名单校验结果err', err)
//       await showLocationFailDialog()
//       throw err
//     }
//   }
// }

Vue.prototype.$gpsLock = async (pointName) => {
  let toast = Toast.loading({
    message: '请稍候...',
    duration: 0,
    forbidClick: true,
    loadingType: 'spinner',
  })
  try {
    const isInWhiteList = await isPointInWhiteList(pointName)
    console.log('====白名单校验结果====', isInWhiteList)
    if (isInWhiteList) {
      toast.clear()
      return { ...WHITELIST_LOCATION }
    }
    try {
      const position = await getUserPosition()
      toast.clear()
      return position
    } catch (error) {
      toast.clear()
      await showLocationFailDialog()
      throw error
    }
  } catch (error) {
    console.log('====获取白名单失败====')
    const position = await getUserPosition()
    toast.clear()
    return position
  }
}
